import React from "react";
import intl from "react-intl-universal";

import { Breadcrumbs } from "components/Breadcrumbs";
import { routing } from "routing";

const { Urls } = routing;

export const BCCreateMatch = () => {
  const breadcrumbs = [
    {
      label: intl.get("SCHEDULE_LABEL"),
      link: Urls.CALENDAR(),
    },
    {
      label: intl.get("SIDEBAR_MANAGE_CREATE_MATCH"),
    },
  ];
  return <Breadcrumbs breadcrumbs={breadcrumbs} />;
};
